import { I18n } from '@aws-amplify/core';
import { SimplePageHeader } from '@flexinet/ui-components';

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Reports')}
        />
    );
};